import { Resource as a, API as o } from "@coveo/platform-client";
const e = class e extends a {
  /**
   * Get search metrics by organization
   * @param options
   * @returns SearchMetricsPageModel
   */
  list(t) {
    return this.api.get(this.buildPath(e.baseUrl, t));
  }
  /**
   * Get search expression performance metrics
   * @param expressionId
   * @param options
   * @returns SearchMetricsModel
   */
  get(t, r) {
    return this.api.get(this.buildPath(`${e.baseUrl}/${t}`, r));
  }
  /**
   * Get search expression product metrics
   * @param expressionId
   * @param options
   * @returns SearchMetricsProductPageModel
   */
  getProducts(t, r) {
    return this.api.get(
      this.buildPath(`${e.baseUrl}/${t}/products`, r)
    );
  }
  /**
   * Get search expression product metric by product id
   * @param expressionId
   * @param productId
   * @param options
   * @returns SearchMetricsProductPageModel
   */
  getProduct(t, r, i) {
    return this.api.get(
      this.buildPath(`${e.baseUrl}/${t}/products/${r}`, i)
    );
  }
};
e.baseUrl = `/rest/organizations/${o.orgPlaceholder}/commerce/reports/v1/queries`;
let s = e;
export {
  s as SearchMetrics
};
//# sourceMappingURL=SearchMetrics.js.map
